import { compose } from 'redux';
import persistState from 'redux-localstorage';
import ENV from '../../env';

const minor_version = ENV.PUSHBOT_VERSION.split('.') // eslint-disable-line camelcase
  .splice(0, 2)
  .join('.');

const localStore = compose(
  persistState('storage', {
    key: `${ENV.PUSHBOT_NAME}@${minor_version}` // eslint-disable-line camelcase
  })
);

export default localStore;



// WEBPACK FOOTER //
// ./js/store/config/localStorage.js